module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isFullscreen ? [_vm.fullscreenClass] : [],
    style: (_vm.isFullscreen ? [_vm.wrapperStyle] : []),
    on: {
      "click": function($event) {
        _vm.shadeClick($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e70a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-fullscreen/src/component.vue
// module id = 958
// module chunks = 0